import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getSupabase } from "../lib/supabase";

export default function AdminProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    let isMounted = true;

    async function checkAdmin() {
      const supabase = await getSupabase();

      // 1. Get session
      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (!session?.user) {
        if (isMounted) {
          setAuthorized(false);
          setLoading(false);
        }
        return;
      }

      // 2. Check admin via RPC
      const { data: isAdmin, error } = await supabase
        .schema("api")
        .rpc("is_admin");

      if (isMounted) {
        setAuthorized(!error && isAdmin === true);
        setLoading(false);
      }
    }

    checkAdmin();

    return () => {
      isMounted = false;
    };
  }, []);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[rgb(var(--brand-surface))]">
        <span className="text-sm text-slate-500 dark:text-slate-400">
          Verifying access…
        </span>
      </div>
    );
  }

  if (!authorized) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}